import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
const ElysSendCemeteryReservationController = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ElysSendCemeteryReservationController.url(args, options),
    method: 'put',
})

ElysSendCemeteryReservationController.definition = {
    methods: ["put"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
ElysSendCemeteryReservationController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
    }

    return ElysSendCemeteryReservationController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
ElysSendCemeteryReservationController.put = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ElysSendCemeteryReservationController.url(args, options),
    method: 'put',
})

export default ElysSendCemeteryReservationController